<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog max-width="500"
                  persistent
                  v-model="$store.getters.licenseModal">
            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Άδειες Χρήσης
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-radio-group label="Παρακαλώ επιλέξτε μία από τις παρακάτω επιλογές" v-model="currentLicenseId">

                        <br>
                        <v-row>
                            <v-col cols="1">
                                <v-radio :key="1" :value="'CC-BY-NC'" @click="updateLicense('CC-BY-NC')" name="radio_license">
                                </v-radio>
                            </v-col>
                            <v-col>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <img src="../../../assets/CC-BY-NC.png" v-on="on">
                                        <p class="font-italic caption text&#45;&#45;secondary">Αναφορά - Μη Εμπορική
                                            Χρήση</p>
                                    </template>
                                    <span>
                                        Δεν επιτρέπεται η εμπορική χρήση των σημειώσεων από τον τελικό χρήστη. <br>
                                        Επιτρέπεται να κάνει αλλαγές στις σημειώσεις ο χρήστης. <br>
                                        Επιτρέπεται οι αλλαγμένες σημειώσεις να μην διανέμονται με τους ίδιους όρους <br>
                                        και προϋποθέσεις όπως οι αρχικές σημειώσεις.
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-col >
                                <a href="https://creativecommons.org/licenses/by-nc/3.0/deed.el"
                                target="_blank">Περισσότερες πληροφορίες</a>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="1">
                                <v-radio :key="2" :value="'CC-BY-NC-ND'" @click="updateLicense('CC-BY-NC-ND')"
                                         name="radio_license">
                                </v-radio>
                            </v-col>
                            <v-col>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <img src="../../../assets/CC-BY-NC-ND.png" v-on="on">
                                        <p class="font-italic caption text&#45;&#45;secondary">Αναφορά - Μη Εμπορική
                                            Χρήση - Όχι Παράγωγα</p>
                                    </template>
                                    <span>
                                        Δεν επιτρέπεται η εμπορική χρήση των σημειώσεων από τον τελικό χρήστη. <br>
                                            Δεν επιτρέπεται να κάνει αλλαγές στις σημειώσεις ο χρήστης.
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-col>
                                <a href="https://creativecommons.org/licenses/by-nc-nd/3.0/deed.el"
                                   target="_blank">Περισσότερες πληροφορίες</a>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="1">
                                <v-radio :key="3" :value="'CC-BY-NC-SA'" @click="updateLicense('CC-BY-NC-SA')"
                                         name="radio_license">
                                </v-radio>
                            </v-col>
                            <v-col>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <img src="../../../assets/CC-BY-NC-SA.png" v-on="on">
                                        <p class="font-italic caption text&#45;&#45;secondary">Αναφορά - Μη Εμπορική
                                            Χρήση - Παρόμοια Διανομή</p>
                                    </template>
                                    <span>
                                       Δεν επιτρέπεται η εμπορική χρήση των σημειώσεων από τον τελικό χρήστη. <br>
                                            Επιτρέπεται να κάνει αλλαγές στις σημειώσεις ο χρήστης. <br>
                                            Δεν Eπιτρέπεται οι αλλαγμένες σημειώσεις να μη διανέμονται με τους ίδιους <br>
                                            όρους και προϋποθέσεις όπως οι αρχικές σημειώσεις.
                                    </span>
                                </v-tooltip>
                            </v-col>
                            <v-col>
                                <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/deed.el"
                                   target="_blank">Περισσότερες πληροφορίες</a>
                            </v-col>
                        </v-row>
                    </v-radio-group>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="closeModal"
                           color="primary"
                           text>
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {eventBus} from "../../../main";

    export default {
        name: "LicenseModal",
        data: () => ({
            currentLicenseId: ''
        }),
        props: {
            licenseId: String,
        },
        methods: {
            updateLicense(licenseId) {
                eventBus.$emit('updateLicense', licenseId);

            },

            closeModal() {
                this.$store.commit('setLicenseModal', false);
            }
        },

        watch: {
            'licenseId': function (value) {
                this.currentLicenseId = value
            }
        }
    }
</script>

<style scoped>

</style>
